import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import type { PostgresTable } from '@shadcn/lib/pg-meta/types';
import { clientFetch } from '~/lib/.client/fetch';
import { invariant } from '~/utils/invariant';
import { projectStore } from '~/lib/stores/project';

export const runQuery = async ({ query }: { query: string }) => {
  try {
    const projectId = projectStore.projectId.get();

    invariant(projectId);

    const response = await clientFetch(`/api/supabase/query/${projectId}`, {
      method: 'POST',
      body: JSON.stringify({ query }),
    });

    const result = await response.json<{ message: string } | PostgresTable[]>();

    if ('message' in result) {
      throw new Error(result.message);
    }

    return result;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : `${error}`);
  }
};

export const useRunQuery = () => {
  return useMutation({
    mutationFn: runQuery,
    onError: (error: { message?: string }) => {
      const message =
        error instanceof Error
          ? error.message
          : typeof error === 'string'
            ? error
            : 'There was a problem with your request.';
      toast.error(message);
    },
  });
};
